import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import MobileWorkspaceScreen from "components/mobile/MobileWorkspaceScreen";

/**
 * Shared layout for Salifert test pages: title, optional data-source chip or custom secondary, intro text, then body.
 */
export default function SalifertTestPageShell({
  title,
  source,
  intro,
  secondary,
  children,
}) {
  const headerSecondary =
    secondary !== undefined ? (
      secondary
    ) : source != null ? (
      <Chip size="small" label={source || "—"} variant="outlined" />
    ) : null;

  return (
    <MobileWorkspaceScreen
      title={title}
      secondary={headerSecondary}
      mobileFillViewport
      sx={{
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      contentSX={{
        px: { xs: 0, md: 1.25 },
        pt: { xs: 0.25, md: 0.75 },
        pb: { xs: 0, md: 1.25 },
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Stack
        spacing={1}
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {intro ? (
          <Box
            sx={{
              flexShrink: 0,
              px: { xs: 1, md: 0 },
              color: "text.secondary",
              typography: "body2",
            }}
          >
            {intro}
          </Box>
        ) : null}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
      </Stack>
    </MobileWorkspaceScreen>
  );
}

SalifertTestPageShell.propTypes = {
  title: PropTypes.string.isRequired,
  source: PropTypes.string,
  intro: PropTypes.node,
  /** If set, replaces the default source chip (e.g. multiple header actions). */
  secondary: PropTypes.node,
  children: PropTypes.node,
};
